"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _H = _interopRequireDefault(require("../H1"));

var _Subtitle = _interopRequireDefault(require("../Subtitle"));

var _HeaderBar = require("../../HeaderBar");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isString = function isString(value) {
  return typeof value === 'string' || value instanceof String;
};

var TitleBar = (0, _styledComponents.default)(_HeaderBar.HeaderBar).withConfig({
  displayName: "TitleBar",
  componentId: "sc-1q1928-0"
})(["", " + ", "{margin-top:8px;}"], _H.default, _Subtitle.default);

var PageTitle = function PageTitle(_ref) {
  var subtitle = _ref.subtitle,
      className = _ref.className,
      children = _ref.children;
  return _react.default.createElement(TitleBar, {
    className: className
  }, _react.default.createElement(_H.default, null, children), subtitle && (isString(subtitle) ? _react.default.createElement(_Subtitle.default, null, subtitle) : subtitle));
};

var _default = PageTitle;
exports.default = _default;